const typographyformEquipServ = {
  text1: 'Sem serviço adicionado',
  text2: 'Tipos de Serviços',
  text3: 'Serviços Realizados',
  servicesCompletedTab: 'Serviços Realizados',
  draftsTab: 'Rascunhos',
  draftStartedAt: 'Iniciado em',
  notDone: 'Sem serviço adicionado',
  inDelay: (days) => days === 1 ? `O serviço está atrasado há ${days} dia` : `O serviço está atrasado há ${days} dias`,
  hasActionsOpenedOrOverdue: (days) => days === 1 ? `O serviço possui ${days} ação aberta ou vencida` : `O serviço possui ${days} ações abertas ou vencidas`,
  zipExport: 'Todos os serviços (.ZIP)',
  allEquipmentServicesReplicateExportPDF: 'Todos os serviços (.PDF)',
  simplifiedExport: 'Relatório Simplificado (.PDF)',
  allEquipmentServicesReplicateWithAttachmentsExportZip: 'Todos os serviços com anexos (.Zip)',
};

export default typographyformEquipServ;
